module.exports = __webpack_public_path__ + "static/media/ic_search.dfd45897.svg";